<script lang="ts">
	import type { BaseProduct, FullProduct } from '$lib/js/elasticsearch/types'
	import { getDeliveryEstimatedDate } from '$lib/js/products'
	import { t } from 'svelte-i18n-lingui'
	import { getContextScope } from '$lib/js/helpers/i18n'

	interface Props {
		type?: string; // "" | product
		product: BaseProduct | FullProduct;
	}

	let { type = '', product }: Props = $props();

	const scope = getContextScope()

  // Take into account the min and max delivery days of the product
	let dates = getDeliveryEstimatedDate({start:product.min_delivery_days, end:product.max_delivery_days, scope: scope })
</script>


<div class="delivery-times {type}">
	<p>{$t`Estimated delivery:`} <b>{dates.start}</b> - <b>{dates.end}</b></p>
</div>


<style lang="scss">
  .delivery-times {
    position: relative;
    margin-top: 6px;
    margin-bottom: 25px;

    &.product {
      margin: 0;

      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
  }
</style>
